export default __webpack_public_path__ + "static/media/widget_watchbox_vpmesc1_buy.9fdb6159.mp3";